// The size / colour of one transaction line, for screens that pick items row
// by row (stock adjustment, transfer, opening stock). Shows nothing when Size &
// Colour is off or the product has no variants.
import React from "react";
import { useSelector } from "react-redux";
import { variantLabel, variantsOf } from "./variants";

const LineVariantSelect = ({ product, value, onChange }) => {
  const on = useSelector((s) => !!s?.settings?.branchsettings?.enableSizeColour);
  const vs = on ? variantsOf(product) : [];
  if (!vs.length) return null;
  return (
    <select
      className="axsc-vsel"
      aria-label="Size and colour"
      value={value || ""}
      onChange={(e) => onChange(vs.find((v) => v.variantID === e.target.value) || null)}
    >
      <option value="">No size / colour</option>
      {vs.map((v) => (
        <option key={v.variantID} value={v.variantID}>
          {variantLabel(v)}
          {v.sku ? ` · ${v.sku}` : ""}
        </option>
      ))}
    </select>
  );
};

export default LineVariantSelect;
